<article class="blog-article">
  <!-- Article Header -->
  <header class="article-header">
        <!-- Title -->
        <h1 class="article-title" [innerHTML]="title"></h1>
    
        <!-- Published Date -->
        @if (publishedDate) {
        <div class="article-published-date">
          {{ formattedPublishedDate }}
        </div>
      }
    
        <!-- Excerpt -->
         @if (excerpt) {
        <div class="article-excerpt">
          <p [innerHTML]="excerpt"></p>
        </div>
      }
    
    <!-- Author Section -->
    <div class="authors-container" *ngIf="author">
      <div class="author">
        <img 
          *ngIf="author.avatarUrl" 
          [src]="author.avatarUrl" 
          [alt]="author.name"
          class="author-avatar"
        />
        <div class="author-info">
          <span class="author-name">{{ author.name }}</span>
          <!-- <span class="author-title" *ngIf="author.title">{{ author.title }}</span> -->
        </div>
      </div>
    </div>
  </header>

  <!-- Article Body -->
  <div class="article-body">
    <div 
      *ngIf="bodyHtml" 
      class="article-content"
      [innerHTML]="safeBodyHtml"
    ></div>
    <div *ngIf="!bodyHtml" class="no-content">
      <p>No content available.</p>
    </div>
  </div>

   <!-- Taxonomy Tags -->
  <section class="taxonomy-section" *ngIf="taxonomyTags.length > 0">
    <div class="taxonomy-container">
      <div class="taxonomy-chips">
        @for (tag of taxonomyTags; track tag.name + tag.category) {
          @if (isChipClickable(tag) && getChipRoute(tag)) {
            <a 
              [routerLink]="getChipRoute(tag)!" 
              [queryParams]="getChipQueryParams(tag)"
              class="taxonomy-chip taxonomy-chip-link" 
              [attr.data-chip-category]="tag.category">
              {{ tag.name }}
            </a>
          } @else {
            <span 
              class="taxonomy-chip" 
              [attr.data-chip-category]="tag.category">
              {{ tag.name }}
            </span>
          }
        }
      </div>
    </div>
  </section>

  <!-- Detailed Author Section with Bio -->
  <section class="authors-detailed-section" *ngIf="author">
    <div class="author-detailed">
      <div class="author-detailed-header">
        <img 
          *ngIf="author.avatarUrl" 
          [src]="author.avatarUrl" 
          [alt]="author.name"
          class="author-detailed-avatar"
        />
        <div class="author-detailed-info">
          <h3 class="author-detailed-name">{{ author.name }}</h3>
          <!-- <p class="author-detailed-title" *ngIf="author.title">{{ author.title }}</p> -->
        </div>
      </div>
      <div 
        *ngIf="author.bio" 
        class="author-detailed-bio"
        [innerHTML]="author.bio"
      ></div>
    </div>
  </section>
</article>

